<template>
    <div id="home">
        <div class="row">
            <div class="col-sm-4">
                <h4>{{ title | uppercase }}</h4>
            </div>
            <div class="col-sm-8">
                <div class="text-right"  v-if="loading">
                    <button class="btn btn-default" @click="refreshDataHandler" disabled>
                        {{ $t('button.refresh')}}
                    </button>
                </div>
                <div class="text-right" v-else>
                    <button class="btn btn-primary" @click="refreshDataHandler">
                        {{ $t('button.refresh')}}
                    </button>
                </div>
            </div>
        </div>


        <br />
        <div class="row ">
            <div class="content">
                <app-readonly-table-map
                    v-bind:parentData="{
                        headers: this.headers,
                        records: this.latest
                    }"
                    v-on:update-prop="updateComponent($event)"
                ></app-readonly-table-map>
            </div>
        </div>

        <div>
          <v-dialog v-model="dialogPhoto" max-width="500px">
            <v-card>
              <img :src="photoHolder">
            </v-card>
            <v-card-actions class="justify-center">
              <v-btn @click="dialogPhoto = false">CLOSE</v-btn>
            </v-card-actions>
          </v-dialog>
        </div>

        <br />
        <div id="shortcut" class="shortcut">
            <h4>{{ $t('title.shortcut') | uppercase }}</h4>
            <hr>
            <div class="row">
                <div class="col">
                    <a>
                        <div class="clocking_analysis short_cut_box">
                            <p><router-link :to="`/${$i18n.locale}/analysis`" class="nav-link">{{ $t('menu.clocking analysis') }}</router-link></p>
                        </div>
                    </a>
                </div>

                <div class="col">
                    <a>
                        <div class="clocking_records short_cut_box">
                            <p>
                            <router-link :to="`/${$i18n.locale}/history`" class="nav-link">{{ $t('menu.clocking records') }}</router-link>
                            </p>
                        </div>
                    </a>
                </div>

                <div class="col">
                    <a>
                        <div class="clocking_data_export short_cut_box">
                            <p>
                                <router-link :to="`/${$i18n.locale}/export/verify`" class="nav-link">{{ $t('menu.export clock data') }}</router-link>
                            </p>
                        </div>
                    </a>
                </div>
                <div class="col">
                    <a><div class="register_staff short_cut_box">
                        <p>
                        <router-link :to="`/${$i18n.locale}/employee/new`" class="nav-link">{{ $t('menu.register staff') }}</router-link>
                        </p>
                    </div></a>
                </div>
                <div class="col">
                    <div class="view_register_staff short_cut_box">
                        <p>
                        <router-link :to="`/${$i18n.locale}/employee`" class="nav-link">{{ $t('menu.view registered staff') }}</router-link>
                        </p>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import axios from 'axios'
import { setTimeout, clearTimeout } from 'timers';

import ReadOnlyTableMaps from './shared/ReadOnlyTableMaps'

export default {
    components: {
        'app-readonly-table-map': ReadOnlyTableMaps
    },

    data () {
        return {
            title: this.$i18n.t('title.latest clocking'),
            headers: [
                    { text: 'FULL NAME', value: 'employee_name', sortable:true},
                    { text: 'COMPANY', value: 'company_name', sortable:true },
                    { text: 'DATE', value: 'clock_date', sortable:true  },
                    { text: 'TIME', value: 'clock_time', sortable:true },
                    { text: 'IN/OUT', value: 'clock_in_out', sortable:false },
                    { text: 'REASON', value: 'reason_name', sortable:true },
                    { text: 'PROJECT', value: 'project_name', sortable:true },
                    { text: 'ID', sortable: false, value: 'id_number' },
                    { text: 'LOCATION', sortable: false, value: 'location'},
                    { text: 'PHOTO CLOCKIN', sortable: false, value: 'photo_clockin'},
                    { text: 'PHOTO CLOCKOUT', sortable: false, value: 'photo_clockout'},
                    { text: 'GEOLOCATION CODE', value: 'geolocation_code', sortable: true },
                    { text: 'GEOLOCATION NAME', value: 'geolocation_name', sortable: true },
            ],
            latest: [],
            pagination: {'sortBy': 'clock_date', 'sortBy': 'clock_time', 'descending': true, 'rowPerPage': -1},
            dialogMap: false,
            center: {lat: 10, lng: 10},
            markers: [],
            loading: false,
            updateData: null,
            dialogPhoto: false,
            photoHolder: null,
            //isRefresh: false
        }
    },

    methods: {
    loadLatest() {
        var vm = this

        this.loading = !this.loading;

        axios.get(this.$store.getters.rootAPI + '/clock/latest')
        .then(function (response) {
            if (response.status !== 401) {
                vm.latest = response.data.rec;
                for (let i = 0; i < vm.latest.length; i++) {
                  vm.latest[i].toggle = false;
                }
                vm.loading = ! vm.loading;
            }

            //this.isRefresh = false
        })
        .catch(function (error) {
            vm.status = 'An error occured.' + error;
        })
    },

    redirectTo(path) {
            this.$router.push(path)
    },

    refreshDataHandler() {
        //this.isRefresh = true
        this.loadLatest()
    },

    updateComponent(photo){
      var vm = this
      vm.photoHolder = photo
      vm.dialogPhoto = !vm.dialogPhoto
    }

    },
/*
  watch: {
      isRefresh() {
          this.refreshDataHandler()

          if (this.isRefresh) {
            this.loadLatest()
          }
      }
  },
*/
  created() {
      this.loadLatest()
  },

}
</script>



// WEBPACK FOOTER //
// src/components/Home.vue